
export const ImageBasePath = '/assets/images/';

export const IconBasePath = '/assets/images/icons.svg#icon-';

export const TeamLogoBasePath = '/assets/images/logo-teams.svg#team-';

export const PlayerImagePath = {
	base: '//nhl.bamcontent.com/images/',
	ext: '@2x.jpg',
	headshot: 'headshots/current/168x168/',
	hero: 'actionshots/',
	arena: 'arena/default/',
};

export const IconType = {
	icon: 'icon',
	logo: 'logo',
};
